module.exports = __webpack_public_path__ + "static/media/tether.a82c4308.svg";